import { useState } from "react";
import type { KeptJob } from "@/lib/tools/tailorAnswer";

export interface TailorValues {
    title: string;
    company: string;
    link: string;
}
type Problems = Partial<Record<keyof TailorValues, string>>;

/**
 * The three answers, kept by the form while its sheet is closed. A job
 * kept for the form fills them in, since a person back from sign-in has a
 * new form, with any problem on the link.
 */
export function useTailorAnswers(kept: KeptJob | null) {
    const [values, setValues] = useState<TailorValues>({ title: "", company: "", link: "" });
    const [problems, setProblems] = useState<Problems>({});
    const [shown, setShown] = useState<KeptJob | null>(null);
    if (kept !== shown) {
        setShown(kept);
        if (kept) {
            const { title, company, address } = kept.job;
            setValues({ title, company, link: address });
            setProblems(kept.problem ? { link: kept.problem } : {});
        }
    }
    const set = (name: keyof TailorValues, value: string) => {
        setValues((current) => ({ ...current, [name]: value }));
        setProblems((current) => ({ ...current, [name]: undefined }));
    };
    return { values, problems, set, setProblems };
}

export type TailorAnswers = ReturnType<typeof useTailorAnswers>;
